import { HOSTS } from '../constants/urlConstants';
import { getEnvironmentStage } from '../util/envUtils';

export const getHostName = () => {
  return HOSTS[getEnvironmentStage()] ?? '';
};

export const buildEndpoint = (endpoint = '') => {
  const hostName = getHostName();
  const url = `${hostName}/${endpoint}`;
  return url ?? '';
};
